/* eslint-disable */
import ReactDOM from 'react-dom'
import React, { useRef, useState, useEffect } from 'react'
import { Canvas, useFrame, useThree, extend } from 'react-three-fiber'

import * as THREE from 'three'
// import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";

// extend({ OrbitControls });

export default function Camera(props) {
    const { camera, gl } = useThree()

    gl.shadowMap.type = THREE.PCFSoftShadowMap
    gl.shadowMap.enabled = true

    camera.fov = 75
    camera.aspect = window.innerWidth / window.innerHeight
    camera.near = 0.1
    camera.far = 15000
    var position = {
        x: 0,
        y: 0,
        z: 500,
    }
    if (props.position) {
        const p = props.position
        var position = {
            x: p[0],
            y: p[1],
            z: p[2],
        }
    }

    var lookAt = {
        x: 0,
        y: 127,
        z: 0,
    }
    if (props.lookAt) {
        const la = props.lookAt
        var lookAt = {
            x: la[0],
            y: la[1],
            z: la[2],
        }
    }

    camera.position.set(position.x, position.y, position.z)
    camera.up.set(0, 1, 1)
    camera.lookAt(new THREE.Vector3(lookAt.x, lookAt.y, lookAt.z))

    let waiting = true
    setTimeout(() => {
        waiting = false
    }, 5000)

    useFrame(({ camera }) => {
        if (props.isAnimating) {
            if (waiting == false) {
                camera.position.x += 10
            }

            if (camera.position.x % 600 == 0 && !waiting) {
                waiting = true
                setTimeout(() => {
                    waiting = false
                }, 1800)
            }
        }
    })

    /* var st = setTimeout(function() {
        props.parentCallback();
        st = null;
    }, 500); */

    return null // <orbitControls args={[camera, gl.domElement]} />;
}
